<template>
    <b-modal
        :visible="isVisibleComputed"
        @change="updateVisibility"
        :title="'Edit ' + (section.parent_id ? 'Subtopic' : 'Topic')"
        @hide="hideModal"
        @ok="updateSection"
        size="lg"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
    >
        <b-form @submit.stop.prevent>
            <b-form-group label="Title">
                <b-form-input v-model="editedSection.title" required></b-form-input>
            </b-form-group>
            <b-form-group label="Description">
                <b-form-textarea v-model="editedSection.description" rows="3"></b-form-textarea>
            </b-form-group>
            <b-form-group label="Icon">
                <div class="icons-container">
                    <div class="d-flex flex-wrap">
                        <b-button
                            v-for="icon in predefinedIcons"
                            :key="icon"
                            :variant="editedSection.icon === icon ? 'success' : 'outline'"
                            class="mr-1 mb-1 icon-button"
                            @click="selectIcon(icon)"
                        >
                            <b-icon :icon="icon" :style="{ color: editedSection.color }"></b-icon>
                        </b-button>
                        <b-button variant="outline" class="mr-1 mb-1" @click="showCustomIconInput = !showCustomIconInput">
                            More
                        </b-button>
                        <b-button
                            :variant="editedSection.icon === null ? 'success' : 'outline'"
                            class="mr-1 mb-1 icon-none"
                            @click="selectIcon(null)"
                        >
                            None
                        </b-button>
                    </div>
                    <div v-if="showCustomIconInput" class="mt-2">
                        <p>Choose an icon <a href="https://icons.getbootstrap.com/" target="_blank">in the Bootstrap library</a> and enter it below.</p>
                        <b-input-group prepend="bi-">
                            <b-form-input v-model="customIcon" placeholder="Enter icon name"></b-form-input>
                            <b-input-group-append>
                                <b-button variant="primary" @click="selectIcon(customIcon)">Set</b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </div>
                </div>
            </b-form-group>
            <b-form-group label="Icon Color">
                <ColorChooser v-model="editedSection.color" />
            </b-form-group>
            <b-form-group>
                <b-form-checkbox v-model="editedSection.is_hidden_for_users" switch>
                    Hide section for users
                </b-form-checkbox>
            </b-form-group>
        </b-form>
        <template #modal-footer="{ ok, cancel }">
            <div class="d-flex justify-content-between w-100">
                <b-button variant="danger" @click="deleteSection">Delete</b-button>
                <div class="d-flex">
                    <b-button variant="outline" class="mr-2" @click="cancel()">Cancel</b-button>
                    <b-button variant="primary" @click="ok()">Save</b-button>
                </div>
            </div>
        </template>
    </b-modal>
</template>

<script>
import ColorChooser from './ColorChooser.vue';

export default {
    name: 'EditSectionModal',
    components: {
        ColorChooser
    },
    props: {
        section: {
            type: Object,
            required: true
        },
        isVisible: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            editedSection: { ...this.section },
            showCustomIconInput: false,
            customIcon: '',
            predefinedIcons: [
                'star',
                'hand-thumbs-up',
                'pin',
                'map',
                'signpost',
                'check-circle',
                'file-check',
                'heart',
                'box'
            ]
        };
    },
    methods: {
        updateVisibility(isVisible) {
            this.$emit('update:isVisible', isVisible);
        },
        hideModal() {
            this.$emit('hide');
        },
        updateSection() {
            this.$emit('update', this.editedSection);
        },
        deleteSection() {
            if (confirm('Are you sure you want to delete this section?')) {
                this.$emit('delete', this.section.id);
            }
        },
        selectIcon(icon) {
            this.editedSection.icon = icon;
            if (icon) {
                this.customIcon = icon;
            }
        },
        setCustomIconIfNeeded() {
            if (this.editedSection.icon && !this.predefinedIcons.includes(this.editedSection.icon)) {
                this.customIcon = this.editedSection.icon;
                this.showCustomIconInput = true;
            }
        }
    },
    computed: {
        isVisibleComputed: {
            get() {
                return this.isVisible;
            },
            set(value) {
                this.$emit('update:isVisible', value);
            }
        }
    },
    watch: {
        section: {
            handler(newSection) {
                this.editedSection = { ...newSection };
                this.setCustomIconIfNeeded();
            },
            deep: true,
            immediate: true
        }
    }
};
</script>

<style scoped>
.icon-button {
    min-width: 40px;
}
.icons-container {
    max-width: 100%;
    overflow-x: auto;
}
</style>